export default __webpack_public_path__ + "static/media/dz.de2f7120.svg";